module.exports = __webpack_public_path__ + "media/images/merit-e7fd8d609f761a99ec59c72609ad053a.png";